import React, { useEffect, useState } from "react";
import FleetPraisoScoreTrend from "../FleetPraisoScoreTrend/FleetPraisoScoreTrend";
import FleetPerformance from "../FleetPerformance/FleetPerformance";
import {
    getEventType,
    getUserData,
    getUserRBAC,
} from "../../services/LocalStorageService";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getAnalytics } from "../../services/GetAnalytics";
import { EntityAccess, EventTypes, RBAC_CODE } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function Analytics(props: any) {
    const params = useParams();
    const { t } = useTranslation();
    const [getRBAC_ScoreTrendCard] = React.useState(
        getUserRBAC(RBAC_CODE.SCORE_TREND_CARD_VIEW, props)
    );
    const [getRBAC_PerformanceCard] = React.useState(
        getUserRBAC(RBAC_CODE.PERFORMANCE_CARD_VIEW, props)
    );
    const [userData] = useState(getUserData);
    const [eventTypes] = useState(getEventType);
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [isApi, setIsApi] = useState(false);
    const [performanceScore, setPerformanceScore] = useState<any>(null);
    const [performanceScoreComputed, setPerformanceScoreComputed] = useState<any>(null);
    const [eventScore, setEventScore] = useState<any>(null);
    const [eventScoreComputed, setEventScoreComputed] = useState<any>(null);
    const [statusValue, setStatusValue] = React.useState<any>(null);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (
            status.code &&
            status.code !== 0 &&
            status.code !== 200 &&
            status.code !== 201
        ) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };
    //====

    async function loadData() {
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        setIsApi(true);
        const data = await getAnalytics(params);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {

            setIsApi(false);
            if (data.content.eventScoreDetails && data.content.eventScoreList) {
                const praisoScoreEvent = await eventTypes.find(
                    (event) => event.code === "PRAISOSCORE"
                );
                const brakingEvent = await eventTypes.find(
                    (event) => event.code === "BRAKING"
                );
                const engagementEvent = await eventTypes.find(
                    (event) => event.code === "ENGAGEMENT"
                );
                const corneringEvent = eventTypes.find(
                    (event) => event.code === "CORNERING"
                );
                const speedingEvent = await eventTypes.find(
                    (event) => event.code === "SPEEDING"
                );
                const distractionEvent = await eventTypes.find(
                    (event) => event.code === "DISTRACTION"
                );
                const accelerationEvent = await eventTypes.find(
                    (event) => event.code === "ACCELERATION"
                );
                const praisoScoreArray = [];
                const brakingScoreArray = [];
                const corneringScoreArray = [];
                const speedingScoreArray = [];
                const engagementScoreArray = [];
                const distractionScoreArray = [];
                const accelerationScoreArray = [];
                for (const item of data.content.eventScoreList) {
                    //Check event id and score is not null
                    const itemPraisoScore = item.eventScores.find(
                        (event) => event.eventTypeId === praisoScoreEvent.id && (event.score !== undefined && event.score !== null)
                    );
                    const itemBrakingScore = item.eventScores.find(
                        (event) => event.eventTypeId === brakingEvent.id && (event.score !== undefined && event.score !== null)
                    );
                    const itemEngagementScore = item.eventScores.find(
                        (event) => event.eventTypeId === engagementEvent.id && (event.score !== undefined && event.score !== null)
                    );
                    const itemCorneringScore = item.eventScores.find(
                        (event) => event.eventTypeId === corneringEvent.id && (event.score !== undefined && event.score !== null)
                    );
                    const itemSpeedingScore = item.eventScores.find(
                        (event) => event.eventTypeId === speedingEvent.id && (event.score !== undefined && event.score !== null)
                    );
                    const itemDistractionScore = item.eventScores.find(
                        (event) => event.eventTypeId === distractionEvent.id && (event.score !== undefined && event.score !== null)
                    );
                    const itemAccelerationScore = item.eventScores.find(
                        (event) => event.eventTypeId === accelerationEvent.id && (event.score !== undefined && event.score !== null)
                    );
                    //Check score is generated for that date
                    if (itemPraisoScore) {
                        const praisoScore = {
                            scoreDate: item.scoreDate,
                            ...itemPraisoScore,
                        };
                        praisoScoreArray.push(praisoScore);


                        if (itemBrakingScore) {
                            const brakingScore = {
                                scoreDate: item.scoreDate,
                                ...itemBrakingScore,
                            };
                            brakingScoreArray.push(brakingScore);
                        } else {
                            const brakingScore = {
                                scoreDate: item.scoreDate,
                                eventTypeId: EventTypes.BRAKING,
                                score: null
                            };
                            brakingScoreArray.push(brakingScore);
                        }

                        if (itemEngagementScore) {
                            const engagementScore = {
                                scoreDate: item.scoreDate,
                                ...itemEngagementScore,
                            };
                            engagementScoreArray.push(engagementScore);
                        } else {
                            const engagementScore = {
                                scoreDate: item.scoreDate,
                                eventTypeId: EventTypes.ENGAGEMENT,
                                score: null
                            };
                            engagementScoreArray.push(engagementScore);
                        }

                        if (itemCorneringScore) {
                            const corneringScore = {
                                scoreDate: item.scoreDate,
                                ...itemCorneringScore,
                            };
                            corneringScoreArray.push(corneringScore);
                        } else {
                            const corneringScore = {
                                scoreDate: item.scoreDate,
                                eventTypeId: EventTypes.CORNERING,
                                score: null
                            };
                            corneringScoreArray.push(corneringScore);
                        }

                        if (itemSpeedingScore) {
                            const speedingScore = {
                                scoreDate: item.scoreDate,
                                ...itemSpeedingScore,
                            };
                            speedingScoreArray.push(speedingScore);
                        } else {
                            const speedingScore = {
                                scoreDate: item.scoreDate,
                                eventTypeId: EventTypes.SPEEDING,
                                score: null
                            };
                            speedingScoreArray.push(speedingScore);
                        }

                        if (itemDistractionScore) {
                            const distractionScore = {
                                scoreDate: item.scoreDate,
                                ...itemDistractionScore,
                            };
                            distractionScoreArray.push(distractionScore);
                        } else {
                            const distractionScore = {
                                scoreDate: item.scoreDate,
                                eventTypeId: EventTypes.DISTRACTION,
                                score: null
                            };
                            distractionScoreArray.push(distractionScore);
                        }

                        if (itemAccelerationScore) {
                            const accelerationScore = {
                                scoreDate: item.scoreDate,
                                ...itemAccelerationScore,
                            };
                            accelerationScoreArray.push(accelerationScore);
                        } else {
                            const accelerationScore = {
                                scoreDate: item.scoreDate,
                                eventTypeId: EventTypes.ACCELERATION,
                                score: null
                            };
                            accelerationScoreArray.push(accelerationScore);
                        }
                    }
                }
                let praisoScoreComputed: any;
                let brakingScoreComputed: any;
                let corneringScoreComputed: any;
                let speedingScoreComputed: any;
                let engagementScoreComputed: any;
                let distractionScoreComputed: any;
                let accelerationScoreComputed: any;
                for (const item of data.content.eventScoreDetails) {
                    if (item.eventTypeId === praisoScoreEvent.id) {
                        praisoScoreComputed = { ...item };
                    } else if (item.eventTypeId === brakingEvent.id) {
                        brakingScoreComputed = { ...item };
                    } else if (item.eventTypeId === corneringEvent.id) {
                        corneringScoreComputed = { ...item };
                    } else if (item.eventTypeId === speedingEvent.id) {
                        speedingScoreComputed = { ...item };
                    } else if (item.eventTypeId === engagementEvent.id) {
                        engagementScoreComputed = { ...item };
                    } else if (item.eventTypeId === distractionEvent.id) {
                        distractionScoreComputed = { ...item };
                    } else if (item.eventTypeId === accelerationEvent.id) {
                        accelerationScoreComputed = { ...item };
                    }
                }

                setPerformanceScoreComputed({
                    praisoScore: praisoScoreComputed,
                });
                setEventScoreComputed({
                    braking: brakingScoreComputed,
                    cornering: corneringScoreComputed,
                    speeding: speedingScoreComputed,
                    engagement: engagementScoreComputed,
                    distraction: distractionScoreComputed,
                    acceleration: accelerationScoreComputed,
                });
                setPerformanceScore({
                    praisoScore: praisoScoreArray.sort(
                        (item1, item2) =>
                            new Date(item1.scoreDate).getTime() - new Date(item2.scoreDate).getTime()
                    ),
                    brakingScore: brakingScoreArray.sort(
                        (item1, item2) =>
                            new Date(item1.scoreDate).getTime() - new Date(item2.scoreDate).getTime()
                    ),
                    corneringScore: corneringScoreArray.sort(
                        (item1, item2) =>
                            new Date(item1.scoreDate).getTime() - new Date(item2.scoreDate).getTime()
                    ),
                    speedingScore: speedingScoreArray.sort(
                        (item1, item2) =>
                            new Date(item1.scoreDate).getTime() - new Date(item2.scoreDate).getTime()
                    ),
                    engagementScore: engagementScoreArray.sort(
                        (item1, item2) =>
                            new Date(item1.scoreDate).getTime() - new Date(item2.scoreDate).getTime()
                    ),
                    distractionScore: distractionScoreArray.sort(
                        (item1, item2) =>
                            new Date(item1.scoreDate).getTime() - new Date(item2.scoreDate).getTime()
                    ),
                    accelerationScore: accelerationScoreArray.sort(
                        (item1, item2) =>
                            new Date(item1.scoreDate).getTime() - new Date(item2.scoreDate).getTime()
                    ),
                });
            }
        } else {
            setIsApiFailed(true);
            setIsApi(false);
            changeApiStatusCodeFunc(data.status);
        }
    }

    useEffect(() => {
        loadData();
        return () => {
            setIsApi(false);
        }
    }, []);

    useEffect(() => {
        if (performanceScore) {
            setEventScore({
                brakingScoreData:
                    performanceScore &&
                    performanceScore.brakingScore &&
                    performanceScore.brakingScore,
                speedingScoreData:
                    performanceScore &&
                    performanceScore.speedingScore &&
                    performanceScore.speedingScore,
                corneringScoreData:
                    performanceScore &&
                    performanceScore.corneringScore &&
                    performanceScore.corneringScore,
                engagementScoreData:
                    performanceScore &&
                    performanceScore.engagementScore &&
                    performanceScore.engagementScore,
                distractionScoreData:
                    performanceScore &&
                    performanceScore.distractionScore &&
                    performanceScore.distractionScore,
                accelerationScoreData:
                    performanceScore &&
                    performanceScore.accelerationScore &&
                    performanceScore.accelerationScore,
            });
        }
    }, [performanceScore]);

    return (
        <>
            {getRBAC_ScoreTrendCard &&
                getRBAC_ScoreTrendCard.isAccessible === EntityAccess.ALLOWED ? (
                <FleetPraisoScoreTrend
                    praisoScore={
                        performanceScore &&
                        performanceScore.praisoScore &&
                        performanceScore.praisoScore
                    }
                    praisoScoreComputed={
                        performanceScoreComputed &&
                        performanceScoreComputed.praisoScore &&
                        performanceScoreComputed.praisoScore
                    }
                    userData={userData}
                    isApiFailed={isApiFailed}
                    isApi={isApi}
                    {...props}
                />
            ) : null}
            {getRBAC_PerformanceCard &&
                getRBAC_PerformanceCard.isAccessible === EntityAccess.ALLOWED ? (
                <FleetPerformance
                    eventScore={eventScore && eventScore}
                    eventScoreComputed={eventScoreComputed && eventScoreComputed}
                    userData={userData}
                    isApiFailed={isApiFailed}
                    isApi={isApi}
                    {...props}
                />
            ) : null}
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
